const AboutUs = () => {
  return (
    <section>
      <div className="container">
        <div className="row pb-5">
          <div className="col-md-6">
            <div className="about_img">
              <img src="images/about1.png" className="w-100" alt="aboutImg" />
            </div>
          </div>
          <div className="col-md-6">
            <h2 className="mt-5 mb-3">About Warraich Traders</h2>
            <p>
              We have completed 5 projects, each project consists of around 50
              houses. We’re a challenge driven team that loves to build
              meaningful living spaces with people that share the same passion
              and values as we have. Our goal is to create New Pakistan, by
              helping each other we will build a happy housing community where
              homeless poor families can get low budget houses in 6 years easy
              installments. We also provide job and shelter for jobless poor
              people.
            </p>
            <div className="row">
              <div className="col-md-6">
                <ul>
                  <li>Dependable And Honesty</li>
                  <li>Planning Schedule</li>
                  <li>100% Customer Satisfaction</li>
                </ul>
              </div>
              <div className="col-md-6">
                <ul>
                  <li>Dependable And Honesty</li>
                  <li>Planning Schedule</li>
                  <li>100% Customer Satisfaction</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
